import { DATA_SOURCES } from 'utils/metrics';
import NoDataSourceMarketCoverage from './NoDataSourceMarketCoverage';

function NoInstagramDataSection(props) {
    return (
        <NoDataSourceMarketCoverage
            dataSource={DATA_SOURCES.INSTAGRAM.key}
            {...props}
        />
    );
}

export default NoInstagramDataSection;
